export default "222222222222\n<app-login></app-login>\n"